var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"indv_card",on:{"click":() => _vm.filtersAction(_vm.card)}},[_c('h2',{staticClass:"cardValue",attrs:{"id":"cardVal"}},[_vm._v(_vm._s(_vm.card.value))]),_c('p',{staticClass:"cardTitle"},[_vm._v(_vm._s(_vm.card.title))])])
}
var staticRenderFns = []

export { render, staticRenderFns }